module.exports = CookieControl;